import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseClient } from '../hooks/useSupabaseClient';
import { Spinner } from '../components/ui/Spinner';

export function Callback() {
  const { supabase } = useSupabaseClient();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      const { data, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('Auth callback error:', error);
        navigate('/login?error=' + encodeURIComponent(error.message));
        return;
      }

      if (data.session) {
        // Successful login, redirect to app
        navigate('/app');
      } else {
        // No session, redirect to login
        navigate('/login');
      }
    };

    handleAuthCallback();
  }, [supabase, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
      <div className="text-center">
        <Spinner size="lg" />
        <p className="mt-4 text-gray-600 dark:text-gray-300">
          Signing you in...
        </p>
      </div>
    </div>
  );
}